import { ROUTER_REPLACE } from "./../constants/types";
import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import router from "@/router/router";
import {routerGoBack, routerPush, routerReplace} from '@/utils/routerStackUtil'

const actions: ActionTree<any, any> = {
  async [types.ROUTER_PUSH]({ state, commit, dispatch }, payload: any) {
    try {
      await router.push(payload);
      // commit(types.ROUTER_PUSH, payload);
      console.log('routerPush');
      routerPush(payload)
    } catch (error) {}
  },
  async [types.ROUTER_GO_BACK]({ state, commit, dispatch }, payload: any) {
    try {
      // console.info("ROUTER_GO_BACK:", {
      //   type: typeof payload,
      //   payLoad: payload
      // });
      if (typeof payload === "number") {
        //如果是number执行go(number),其他支持通过name返回到对应的router
        await router.go(payload);
      }
      console.log('routerGoBack');
      routerGoBack(payload)
    } catch (error) {}
  },
  async [types.ROUTER_REPLACE]({ state, commit, dispatch }, payload: any) {
    try {
      await router.replace(payload);
      console.log('routerReplace');
      routerReplace(payload)
    } catch (error) {}
  }
};

export default actions;
